import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./SelectMenuStyles";
import { energyActions } from "../_actions";
import moment from "moment";

export default class SelectMenu extends Component {
  componentDidMount() {
    if (this.props.energy.detail.details)
      this.props.dispatch(
        energyActions.setDetailItem(
          this.props.energy.detail.available[
            this.props.energy.detail.available.length - 1
          ]
        )
      );
  }
  render() {
    let momentFormat,
      textFormat,
      momentAdjust,
      optionArray = [];
    const {
      energy: { detail }
    } = this.props;

    if (detail.period.time_unit === "hour") {
      momentFormat = "ha";
      textFormat = "Hour";
      momentAdjust = { hour: 1 };
    } else if (detail.period.time_unit === "day") {
      momentFormat = "dddd Do MMMM";
      textFormat = "Day";
      momentAdjust = null;
    } else if (detail.period.time_unit === "week") {
      momentFormat = "Do MMMM";
      textFormat = "Week";
      momentAdjust = { day: 6 };
    } else if (detail.period.time_unit === "month") {
      momentFormat = "MMMM";
      textFormat = "Month";
      momentAdjust = null;
    }

    for (var i = detail.available.length - 1; i >= 0; i--) {
      optionArray.push(
        <option
          key={`selectItem${i}`}
          value={detail.available[i]}
        >{`${moment.unix(detail.available[i]).format(momentFormat)} ${
          momentAdjust ? "to" : ""
        } ${
          momentAdjust
            ? moment
                .unix(detail.available[i])
                .add(momentAdjust)
                .format(momentFormat)
            : ""
        }`}</option>
      );
    }

    return (
      <div>
        <div className={css(styles.selectWrapper)}>
          <select
            className={css(styles.select)}
            value={this.props.energy.detailItem}
            onChange={e =>
              this.props.dispatch(energyActions.setDetailItem(e.target.value))
            }
          >
            {optionArray}
          </select>
          <span className={css(styles.arrow)}>
            <span
              className={css(styles.changeText)}
            >{`Change ${textFormat}`}</span>
          </span>
        </div>
        <div className={css(styles.timeSelectWrapper)}>
          <button
            className={css(styles.timeButton)}
            disabled={detail.previous == null ? true : false}
            onClick={e =>
              this.props.dispatch(energyActions.setDetailItem(detail.previous))
            }
          >
            <img
              className={css(styles.timeButtonIcon)}
              src={"/icons/previous.svg"}
            />
            {`Previous ${detail.period.time_unit}`}
          </button>{" "}
          <button
            className={css(styles.timeButton)}
            disabled={detail.next == null ? true : false}
            onClick={e =>
              this.props.dispatch(energyActions.setDetailItem(detail.next))
            }
          >
            {`Next ${detail.period.time_unit}`}
            <img
              className={css(styles.timeButtonIconRight)}
              src={"/icons/next.svg"}
            />
          </button>
        </div>
      </div>
    );
  }
}
